import React from 'react';

import { Alert, AlertColor, AlertTitle, Snackbar, SxProps, Theme, Typography, TypographyProps } from '@mui/material';

type SnakebarToasterProps = {
  title?: string;
  isOpen: boolean;
  sx?: SxProps<Theme>;
  withTitle?: boolean;
  severity: AlertColor;
  icon?: React.ReactNode;
  content: React.ReactNode;
  autoHideDuration?: number;
  contentStyles?: SxProps<Theme>;
  variant?: TypographyProps['variant'];
  onClose?: () => void;
};

export const SnakebarToaster: React.FunctionComponent<SnakebarToasterProps> = ({
  sx,
  icon,
  title,
  isOpen,
  variant,
  content,
  severity,
  contentStyles,
  withTitle = false,
  autoHideDuration = 10000,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    onClose();
  };

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={handleCloseSnackbar}
      sx={{ mt: '2rem', ...sx }}
    >
      <Alert severity={severity} onClose={onClose} icon={icon}>
        {withTitle && <AlertTitle>{title}</AlertTitle>}
        <Typography variant={variant} sx={contentStyles}>
          {content}
        </Typography>
      </Alert>
    </Snackbar>
  );
};
